import React, { useEffect, createElement } from 'react';
import { Section } from './Section';
import { CalendarIcon, ShieldCheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const CALENDLY_URL = 'https://calendly.com/portegehoy2026/asesoria-de-proteccion-y-finanzas-familiares';
export function CTA() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <Section bg="navy-light" id="agenda" data-id="element-31">
      <div className="max-w-4xl mx-auto text-center" data-id="element-32">
        <ShieldCheckIcon className="w-10 h-10 md:w-16 md:h-16 text-gold mx-auto mb-4 md:mb-8" data-id="element-33" />

        <p className="text-base md:text-2xl text-white font-playfair leading-relaxed mb-6 md:mb-12" data-id="element-34">
          La asesoría de diseño patrimonial{' '}
          <span className="text-gold font-bold" data-id="element-35">no tiene costo inicial</span>.
          El objetivo es filtrar si tu perfil califica para un Blindaje Dotal
          acorde a tu nivel de ingresos.
        </p>

        <motion.a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="w-full md:w-auto bg-gold hover:bg-gold-hover text-navy font-bold text-base md:text-xl px-6 md:px-8 py-4 md:py-5 rounded-full shadow-[0_0_40px_rgba(201,168,76,0.3)] transition-colors inline-flex items-center justify-center gap-2 md:gap-3 mx-auto mb-6 md:mb-12" data-id="element-36">
          <CalendarIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-37" />
          AGENDAR MI ASESORÍA DE BLINDAJE
        </motion.a>

        {/* Calendly Inline Widget */}
        <div id="calendly-widget" className="calendly-inline-widget w-full max-w-3xl mx-auto mb-4 md:mb-8 rounded-xl md:rounded-2xl overflow-hidden shadow-2xl border border-white/10" data-url={`${CALENDLY_URL}?background_color=0f1f3a&text_color=ffffff&primary_color=c9a84c`} style={{
        minWidth: '320px',
        height: '600px'
      }} data-id="element-38"></div>

        <div className="inline-flex items-center gap-2 bg-gold/10 border border-gold/30 text-gold px-4 md:px-6 py-2 md:py-3 rounded-full text-xs md:text-sm font-medium" data-id="element-39">
          <CalendarIcon className="w-3.5 h-3.5" data-id="element-40" />
          Agenda por tiempo limitado de manera gratuita
        </div>
      </div>
    </Section>;
}